import * as Yup from "yup";

export const acquirerSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome muito curto")
        .required("O nome da adquirente é obrigatório"),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),

    // Taxas por bandeira — mapa dinâmico { visa: {...}, mastercard: {...} }
    rates: Yup.mixed().default({}),

    // Antecipação de Recebíveis
    anticipation: Yup.object().shape({
        enabled: Yup.boolean().default(false),
        type: Yup.string().oneOf(["automatic", "manual"]).default("automatic"),
        feePerMonth: Yup.number().min(0, "Taxa não pode ser negativa").default(0),
        settlementDays: Yup.number().min(0).max(31).default(1),
    }),

    // Conta bancária de destino
    idBankAccount: Yup.string().nullable(),
    bankAccountName: Yup.string(),
});

